const environmentCrypto = {
    API_BASE_URL: 'https://api-ifcrypto.if-security.com',
    GO_API_BASE_URL: 'https://api-ifcrypto.if-security.com',
    FEATURES: {
        IS_PROP: true,
        PRODUCTS: true,
        HAS_TRIAL: true,
        BANNERS: false,
        RULES_SECTION: false,
        ACCOUNT_SCALING: false,
        CHALLENGES_SECTION: false,
        THEME_CHANGE: false,
        REGISTER_SECTION: false,
        SMART_DRAWDOWN: false
    },
    THEME_COLORS: {
        PRIMARY: '#FF1764',
        BLACK: '#1E1E1E',
        BACKGROUND: '#F6F6F6',
        BLACK_50_TEXT: '#8E8E8E',
        BLACK_20_STROKE: '#D2D2D2',
        BLACK_8_DIVIDER: '#EDEDED',
        BRAND_HOVER: '#FF4885',
        BLACK_HOVER: '#2A2A2A',
        SYSTEM_GREEN: '#00A800',
        SYSTEM_YELLOW: '#FF7011',
        SYSTEM_RED: '#FF3111'
    },
    TITLE_FONT_FAMILY: 'Onest',
    CRYPTO_LOGO: true,
    DAILY_RESET_HOUR: 17,
    TIMEZONE: 'America/New_York',
    RECAPTCHA: {
        ENABLED: true,
        SITE_KEY: '6LeCZ2wrAAAAAAWVmFSQf08dAYZha5pcP8fN5caT',
        SITE_KEY_INVISIBLE: '6Lf973YrAAAAABuvDAei_T04gB7Brda_OP-YY5oR'
    }
};
export default environmentCrypto;
